import React, { Component } from 'react'
import axios from 'axios'
import Header from '../../Components/Header/Header'
import Content from '../../Components/Content/Content'
import Footer from '../../Components/Footer/Footer'
import { withRouter } from 'react-router'
import Spinner from 'react-spinner'
import '../../assets/app.css'
import $ from 'jquery'
import ReactGA from 'react-ga4'
import TagManager from 'react-gtm-module'

class Builder extends Component {

	loadJquery() {
		$(document).ready(function () {
			if (!$('#myModal').length) {
				$('#root').append(
					'<div id="myModal" class="lightbox-modal"><span class="lightbox-close lightbox-cursor">&times;</span><div class="lightbox-modal-content"><div class="lightbox-mySlides"><img id="lightbox-image" src="https://iccpi.eu/_files/foto/83/erard_1838.png" style="width:100%" alt="lightbox image"></div></div></div>'
				)
			}

			$('.rollerPointer').click(function (event) {
				$('html, body').animate(
					{
						scrollTop: $('.middle-scrollPoint').offset().top,
					},
					1000
				)
			})

			/**Lightbox START**/
			$('.lightbox').on('click', function (event) {
				$('#lightbox-image').attr('src', event.target.src)
				$('#myModal').fadeIn('slow', function () {
					$(this).css('display', 'block')
				})
			})

			$('.lightbox-close.lightbox-cursor').on('click', function (event) {
				$('#myModal').fadeOut('slow', function () {
					$(this).css('display', 'none')
				})
			})
			/**Lightbox END**/
		})
	}

	/*load Builder and init start data*/
	constructor(props) {
		super(props)

		this.state = {
			path: this.props.location.pathname,
			data: null,
			top: null,
			middle: null,
			bottom: null,
			middleUrl: null,
		}

		this.getData()
	}

	getContentOrigin() {
		try {
			if (window.siteBaseHost && typeof window.siteBaseHost === 'string') {
				return window.siteBaseHost.replace(/\/$/, '')
			}

			if (window.globalUrl) {
				const parsed = new URL(window.globalUrl)
				return `${parsed.protocol}//${parsed.host}`
			}
		} catch (error) {
			console.warn('Unable to resolve content origin, falling back to window.location.origin:', error)
		}

		return window.location.origin
	}

	getSiteKey(hostname) {
		if (!hostname) {
			return 'nifc'
		}

		const parts = hostname.split('.').filter(Boolean)

		if (!parts.length) {
			return 'nifc'
		}

		if (parts[0] === 'www' && parts.length > 1) {
			return parts[1]
		}

		return parts[0]
	}

	buildPageBuilderApiUrl() {
		const encodedPath = window.btoa(this.state.path.slice(1, this.state.path.length))

		let hostname = 'nifc.pl'

		try {
			const origin = this.getContentOrigin()
			hostname = new URL(origin).hostname || hostname
		} catch (error) {
			console.warn('Unable to parse content origin hostname, defaulting to nifc.pl:', error)
		}

		const siteKey = this.getSiteKey(hostname)
		const apiHost = siteKey ? `api-${siteKey}.nifc.pl` : 'api-nifc.nifc.pl'

		return `https://${apiHost}/index.php/main/page_builder/${encodedPath}`
	}

	componentDidMount() {
		var pathArray = window.globalUrl.split('/')
		var firstPart = pathArray[1]
		var secondPart = pathArray[2]
		var thirdPart = pathArray[3]
		var fourthPart = pathArray[4]
		window.apiLink = 'https:/' + firstPart + '/' + secondPart + '/' + thirdPart + '/' + fourthPart + '/web_config'
		window.extraConfig =
			'https:/' + firstPart + '/' + secondPart + '/' + thirdPart + '/' + fourthPart + '/external_scripts'

		axios
			.get(window.apiLink)
			.then(res => {
				res.data.page_title ? (document.title = res.data.page_title) : null
			})
			.catch(function (error) {
				console.log('API config error:', error)
			})

		axios
			.get(window.apiLink)
			.then(res => {
				res.data.ga_code ? ReactGA.initialize(res.data.ga_code) : null
				res.data.ga_code ? ReactGA.send('pageview') : null
			})
			.catch(function (error) {
				console.log(error)
			})

		axios
			.get(window.apiLink)
			.then(res => {
				const tagManagerArgs = { gtmId: res.data.gtm_code }
				res.data.gtm_code ? TagManager.initialize(tagManagerArgs) : null
			})
			.catch(function (error) {
				console.log(error)
			})

		this.updateHtmlLang()
	}

	componentDidUpdate(prevProps) {
		if (this.props.location !== prevProps.location) {
			this.updateHtmlLang()
		}
	}

	getLangFromUrl() {
		const path = window.location.pathname
		const lang = path.split('/')[1]
		return lang
	}

	updateHtmlLang() {
		const lang = this.getLangFromUrl()
		document.documentElement.lang = lang
	}

	/*receive a new url and reload data*/
	componentWillReceiveProps(nextProps) {
		this.state = {
			path: nextProps.location.pathname,
			data: null,
			top: null,
			middle: null,
			bottom: null,
		}

		this.getData()
	}

	getData() {
		var parent = this

		const newLink = () => {
			let prevLink = this.state.path.slice(1, this.state.path.length).split('/')
			let newLinkEnd = prevLink[prevLink.length - 1].split('_')
			prevLink.pop()
			let newLink = ''
			prevLink.forEach(item => {
				newLink = newLink + item + '/'
			})
			newLink = newLink + newLinkEnd[0]
			return window.btoa(newLink)
		}

		if (this.state.data === null) {
			// console.log("Loading builder...");
			// var apiUrl = 'https://api-nifc.nifc.pl/index.php/main/page_builder/' + window.btoa(this.state.path.slice(1, this.state.path.length));
			// var apiUrl = 'https://api-chopin.nifc.pl/index.php/main/page_builder/' + window.btoa(unescape(encodeURIComponent(this.state.path)).slice(1, this.state.path.length));
			// var apiUrl = "https://api-muzyka.nifc.pl/index.php/main/page_builder/" + window.btoa(this.state.path.slice(1, this.state.path.length));
			// var apiUrl = 'https://api-festiwal.nifc.pl/index.php/main/page_builder/' + window.btoa(this.state.path.slice(1, this.state.path.length));
			// var apiUrl = 'https://api-nauka.nifc.pl/index.php/main/page_builder/' + window.btoa(this.state.path.slice(1, this.state.path.length));
			// var apiUrl = "https://api-muzeum.nifc.pl/index.php/main/page_builder/" + window.btoa(this.state.path.slice(1, this.state.path.length));
			var apiUrl = 'https://api-konkurs.nifc.pl/index.php/main/page_builder/' + window.btoa(this.state.path.slice(1, this.state.path.length));
			// var apiUrl = 'https://api-publikacje.nifc.pl/index.php/main/page_builder/' + newLink();
			// var apiUrl = 'https://api-bip.nifc.pl/index.php/main/page_builder/' + window.btoa(this.state.path.slice(1, this.state.path.length));
			// var apiUrl = 'https://api-iccpi.nifc.pl/index.php/main/page_builder/' + window.btoa(this.state.path.slice(1, this.state.path.length));


			// var apiUrl = "https://api-ksiazkiiplyty.nifc.pl/index.php/main/page_builder/" + window.btoa(this.state.path.slice(1, this.state.path.length));
			// var apiUrl = 'http://192.168.60.2/nifc_nowa_strona/api/index.php/main/page_builder/' + window.btoa(this.state.path.slice(1, this.state.path.length));
			// var apiUrl = 'http://dev.seraaq.com/nifc_nowa_strona/api/index.php/main/page_builder/' + window.btoa(this.state.path.slice(1, this.state.path.length));
			// var apiUrl = 'https://api05.nifc.pl/index.php/main/page_builder/' + window.btoa(this.state.path.slice(1, this.state.path.length));
			// var apiUrl = 'https://api-pmp.nifc.pl/index.php/main/page_builder/' + window.btoa(this.state.path.slice(1, this.state.path.length));


			// this make infinite loop
			// const contentOrigin = this.getContentOrigin()
			// const sanitizedOrigin = contentOrigin.replace(/\/$/, '')
			// window.globalUrl = sanitizedOrigin + this.state.path

			// const apiUrl = this.buildPageBuilderApiUrl()
			// window.pageBuilderApiUrl = apiUrl

			window.globalUrl = apiUrl

			axios
				.get(apiUrl)
				.then(res => {
					const data = res.data
					this.setState({ data: data })

					this.loadTopComponentData(this.state.data)
					this.loadMiddleComponentData(this.state.data)
					this.loadBottomComponentData(this.state.data)
				})
				.catch(function (error) {
					console.log(error)
					setTimeout(function () {
						parent.getData()
					}, 3000)
				})
		}
	}

	loadTopComponentData(config) {

		var apiUrl = config.top_component_endpoint
		axios.get(apiUrl).then(res => {
			let data = res.data

			const homeLink = { id: '8', name: 'Home', url: 'https://nifc.pl/pl/' }

			if (data.main_menu) {
				data.main_menu.unshift(homeLink)
			}

			if (data.main_menu_sub_mobile) {
				data.main_menu_sub_mobile.unshift(homeLink)
			}

			this.setState({ top: data })
		})
	}

	loadMiddleComponentData(config) {

		var apiUrl = config.middle_component_endpoint
		const optSearch = sessionStorage.getItem('OptSearch')
		const optSearchUrl = sessionStorage.getItem('OptSearchUrl')
		const singleSearch = sessionStorage.getItem('singleSearch')
		const singleSearchUrl = sessionStorage.getItem('singleSearchUrl')
		const link = window.location.pathname
		const urlParams = new URLSearchParams(window.location.search)

		let paramsObject = {}

		for (let [key, value] of urlParams.entries()) {
			paramsObject[key] = value
		}

		if (optSearch !== null && optSearch === link) {
			//console.log("optSearchUrl");
			axios.post(apiUrl, `search=${optSearch}`).then(res => {
				const data = res.data
				this.setState({ middle: data, middleUrl: apiUrl })
			})
		} else if (singleSearchUrl !== null && singleSearchUrl === link) {
			//console.log("singleSearchUrl");
			axios.post(apiUrl, `search=${singleSearch}`).then(res => {
				const data = res.data
				this.setState({ middle: data, middleUrl: apiUrl })
			})
		} else if (Object.keys(paramsObject).length > 0) {
			axios.post(apiUrl).then(res => {
				const tmpMiddle = res.data

				axios.post(apiUrl, `search=${JSON.stringify(paramsObject)}`).then(res => {
					const newData = res.data
					const data_final = {
						...tmpMiddle,
						...newData,
						events: newData.events || tmpMiddle.events,
					}

					this.setState({ middle: data_final, middleUrl: apiUrl }, () => {
						// console.log('Updated State:', this.state.middle);
					})
				})
			})
		} else {
			axios.post(apiUrl).then(res => {
				//console.log('other');
				const data = res.data
				this.setState({ middle: data, middleUrl: apiUrl })
			})
		}
	}

	// loadMiddleComponentData(config) {
	//     var apiUrl = config.middle_component_endpoint;
	//     const link = window.location.pathname;
	//     const urlParams = new URLSearchParams(window.location.search);

	//     let paramsObject = {};

	//     for (let [key, value] of urlParams.entries()) {
	//         paramsObject[key] = value;
	//     }

	//     console.log(paramsObject);

	//     axios.post(apiUrl, `search=${JSON.stringify(paramsObject)}`).then(res => {
	//         const data = res.data;
	//         this.setState({ middle: data, middleUrl: apiUrl });
	//     });
	// }

	// loadMiddleComponentData(config) {
	//     var apiUrl = config.middle_component_endpoint;
	//     const optSearch = sessionStorage.getItem('OptSearch');
	//     const optSearchUrl = sessionStorage.getItem('OptSearchUrl');
	//     const singleSearch = sessionStorage.getItem('singleSearch');
	//     const singleSearchUrl = sessionStorage.getItem('singleSearchUrl');
	//     const link = window.location.pathname;
	//     const urlParams = new URLSearchParams(window.location.search);

	//     let paramsObject = {};

	//     // Odczytaj wszystkie parametry z URL i zapisz do obiektu paramsObject
	//     for (let [key, value] of urlParams.entries()) {
	//         paramsObject[key] = value;
	//     }

	//     // Jeśli są parametry w URL, wykonaj zapytanie z tymi parametrami
	//     if (Object.keys(paramsObject).length > 0) {
	//         axios.post(apiUrl, `search=${JSON.stringify(paramsObject)}`).then(res => {
	//             const data = res.data;
	//             this.setState({ middle: data, middleUrl: apiUrl }, () => {
	//                 console.log('Updated State:', this.state.middle);
	//             });
	//         });
	//     } else {
	//         // Jeśli nie ma parametrów, załaduj domyślne dane
	//         axios.post(apiUrl).then(res => {
	//             const data = res.data;
	//             this.setState({ middle: data, middleUrl: apiUrl });
	//         });
	//     }
	// }

	loadBottomComponentData(config) {

		var apiUrl = config.bottom_component_endpoint
		axios.get(apiUrl).then(res => {
			const data = res.data
			this.setState({ bottom: data })
		})
	}

	render() {
		if (
			this.state.data !== null &&
			this.state.top !== null &&
			this.state.middle !== null &&
			this.state.bottom !== null
		) {
			window.globalColor = `#${this.state.data.gbcolor}`
			return (
				<div>
					<Header data={this.state.top} data2={this.state.middle} config={this.state.data} />
					<Content
						data={this.state.middle}
						config={this.state.data}
						breadcrumbs={this.state.path}
						middleUrl={this.state.middleUrl}
					/>
					<Footer data={this.state.bottom} config={this.state.data} />
					{this.loadJquery()}
				</div>
			)
		} else {
			return (
				<div className="spinner_background">
					<Spinner />
				</div>
			)
		}
	}
}

export default withRouter(Builder)



// WEBPACK FOOTER //
// ./src/Components/Builder/Builder.js